/**
 * Created by rhinov8e on 20/11/2015.
 *
 * UI idle State when there is nothing to do at all
 */

import { math } from "@rhinov/savane-js";
import { UiState, UiStateEnum } from "./UiState";

export class UiIdleState extends UiState {
    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3) {
        super(cursorPosition, cocosPosition);
    }

    // Returns the next UiState to go to depending on current action
    getUiState(): number {
        return UiStateEnum.uiIdleState;
    }

    // The mouse is moving in this state
    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        // Store cursor and cocos cursor positions
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;

        // Execute setSelected method (inherited) to determine hovering and selection if mouse button clicked
        this.setSelected();

        // If next ui state === current state, then quit without changing state
        if (this.getNextUiState() === this.getUiState()) {
            return null;
        }
        else {
            //  Create next Ui state for next loop and return it for activation
            return this.createNextUiState();
        }
    }
}
